import { genericCallWithBody, genericGetWithParameters, genericDeleteWithParameters } from "./Networking";

export const getListOfMessages = async () => {
    const userID = localStorage.getItem('UserID');
    try {
      const params = {
        UserId: userID
      };
      const response = await genericGetWithParameters('Message/Get', params);
      return response;
    } catch (error) {
      console.error(error);
    }
  };

export const markMessageAsRead = async (messageId) => {
  try {
    const params = {
      MessageId: messageId
    };
    const response = await genericCallWithBody('POST', 'Message/DismissMessage', params);
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const getReplyHistoryByMessageID = async (messageID) => {
  try {
    const params = {
      'MessageID': messageID
    }
    const response = await genericGetWithParameters('Message/GetReplyHistoryByMessageID', params);
    return response;
  } catch (error) {
    console.error(error);
  }
}

export const PublicMessagesSave = async (body) => {
  try {
    const response = await genericCallWithBody('POST', 'Message/PublicMessagesSave', body);
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const PublicMessagesDelete= async (messageID) => {
    try{
        let params = {
            'messageID': messageID,
        };
        let response = await genericDeleteWithParameters('Message/PublicMessagesDelete',params);
        return response;
    } catch (error) {
        console.error(error);
    }
}

export const PublicMessagesGet = async () => {
  try {
    const params = null
    const response = await genericGetWithParameters('Message/PublicMessagesGet', params);
    return response;
  } catch (error) {
    console.error(error);
  }
}